// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_1rB1KrcS3Tpp5zTTf_4XdX","spaceLeft":"_34N4p31cmdmMlUiNvvffQh","spaceBoth":"_12MWuBTnEaM0LNy5ci6-_F","spaceRight":"l6fix2aSCEeV0bKrd6rlK","Cross":"KhilHvFtNLM0S-FZv9l4q","Close":"_2nIQevY6Ph08ggs9AjAgi2","MessageBoard":"_2KEXHlKumwtxS6HHBBWlJE","Heading":"_3GtxT6KUN5LBEenCKDaovg","MessageBoard--Info":"_1h4G3kSF4uQrqzW-wJpsVi","MessageBoard--Warning":"_5Y2RKvK2JMfWNOJZbqERV","Circle":"UyLrkyksx9aRftZ6vSQlC","Number":"EnCDnw3wvh3hSHh_YB7FS","FilledCircle":"tNMzbR8qlkT0_Lbb_Zi3C","Circle--Red":"_35bzaksTEXmN7JGeu8Lb31","Text":"cvvX4jO7T5RTEFf0KIWpk","InfoMessagesSection":"_16L03h72wRR1G3xUhbm3Qg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisMessage.scss
// module id = 331
// module chunks = 0